export class NewSusbcriberModel{
    id:number;
    name:string;
    status:string;
    serviceType:string;
    
 }